/* global jQuery */
import isAdmin from '../../../helpers/isAdmin';

( ( $ ) => {
	const initializeBlock = ( $block ) => {
		if ( ! $block.length || isAdmin ) {
			return;
		}

	/*	const dotsEnabled = ( $block.parent().hasClass( 'template-cards' ) || $block.parent().hasClass( 'careers-carousel' ) || $block.parent().hasClass( 'template-redesign' ) || $block.parent().hasClass( 'template-redesign-withStat' ) ) ? true : false;*/

		$block.slick( {
			dots: true,
			infinite: true,
			speed: 300,
			arrows: true,
			slidesToShow: 1,
			adaptiveHeight: true,
			focusOnSelect: false,
			focusOnChange: false,
			//prevArrow: '<span class="prev slick-prev"></span>',
			//nextArrow: '<span class="next slick-next"></span>',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						dots: true,
						arrows: false,
						slidesToShow: 1,
					},
				},
			],
		} );

		/*ACCESSIBILITY FIX SO CAROUSEL SLIDE CAN'T BE FOCUSED*/
		$( '.quote-carousel-slider .slick-slide' ).attr( 'tabindex', -1 );

		$( '.quote-carousel-slider' ).on('afterChange', function(event, slick, currentSlide, nextSlide){
			setTimeout(function() {
				$(slick.$slides.get(currentSlide)).attr( 'tabindex', -1 );
			}, 500);
			
		  });

		const ua = navigator.userAgent.toLowerCase();

		if ( ua.indexOf( 'safari' ) !== -1 ) {
			if ( ua.indexOf( 'chrome' ) > -1 ) {
				return;
			}

			$( '.quote-by-image img', $block ).each( ( _index, element ) => {
				const $element = $( element );

				const oldWidth = $element.attr( 'width' );
				const oldHeight = $element.attr( 'height' );
				const maxW = 156;
				let height = 75;
				let width = parseInt( oldWidth * height / oldHeight, 10 );

				if ( width > maxW ) {
					height = parseInt( maxW * height / width, 10 );
					width = maxW;
				}

				$( element ).css( { height, width, maxWidth: width, maxHeight: height } );
			} );
		}

		
	};



	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		$( '.quote-carousel-slider' ).not( '.slick-initialized' ).each( ( _index, element ) => {
			initializeBlock( $( element ) );
		} );
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=quote-carousel',
			initializeBlock
		);
	}
} )( jQuery );
